import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    width: '100%',
  },
  textField: {
    width: '100%'
  }
}));
